import "./styles.scss";

export interface ICarouselImageSliderProps {
  url: string;
}

export const CarouselImageSlider = ({ url }: ICarouselImageSliderProps) => (
  <img className="image-slider" src={url} alt="Room" />
);
